import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import SaveIcon from "@material-ui/icons/Save";
import PersonIcon from "@material-ui/icons/Person";
import PhoneIcon from "@material-ui/icons/Phone";
import ScheduleIcon from "@material-ui/icons/Schedule";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InfoIcon from "@material-ui/icons/Info";
import SendIcon from "@material-ui/icons/Send";
import api from "../../services/api";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import { i18n } from "../../translate/i18n";

const BirthdaySettingsPage = () => {
  const { whatsApps } = useContext(WhatsAppsContext);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    user: true,
    contact: true,
    general: true
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const { data } = await api.get("/birthdays/settings");
      setSettings(data.data);
    } catch (error) {
      toast.error(i18n.t("birthdaySettings.toasts.loadError"));
    } finally {
      setLoading(false);
    }
  };

  const handleSettingChange = (field, value) => {
    setSettings(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put("/birthdays/settings", settings);
      toast.success(i18n.t("birthdaySettings.toasts.saveSuccess"));
    } catch (error) {
      toast.error(i18n.t("birthdaySettings.toasts.saveError"));
    } finally {
      setSaving(false);
    }
  };

  const handleTestMessage = async (messageType) => {
    const contactId = prompt("Digite o ID de um contato para teste:");
    if (!contactId) return;

    try {
      await api.post("/birthdays/test-message", {
        contactId: parseInt(contactId),
        messageType
      });
      toast.success(i18n.t("birthdaySettings.toasts.testSuccess"));
    } catch (error) {
      toast.error(i18n.t("birthdaySettings.toasts.testError"));
    }
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const renderMessagePreview = (message) => {
    if (!message) return null;

    let previewMessage = message;
    previewMessage = previewMessage.replace(/{nome}/g, "João Silva");
    previewMessage = previewMessage.replace(/{idade}/g, "30");

    return (
      <div
        style={{
          background: "#f9fafb",
          padding: "12px",
          borderRadius: "6px",
          marginTop: "8px",
          border: "1px solid #e8ecf1",
        }}
      >
        <div style={{ fontSize: "11px", color: "#6b7280", marginBottom: "4px" }}>
          {i18n.t("birthdaySettings.preview")}
        </div>
        <div style={{ fontSize: "13px", color: "#1a1a1a" }}>
          {previewMessage}
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div style={{ padding: "24px", background: "#f5f7fa", minHeight: "100vh" }}>
        <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
          {i18n.t("birthdaySettings.loading")}
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: "24px", background: "#f5f7fa", minHeight: "100vh" }}>
      {/* Header */}
      <div style={{ marginBottom: "24px" }}>
        <h1 style={{ fontSize: "24px", fontWeight: 700, color: "#1a1a1a", margin: 0 }}>
          🎂 {i18n.t("birthdaySettings.title")}
        </h1>
      </div>

      {/* Configurações de Usuários */}
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          border: "1px solid #e8ecf1",
          marginBottom: "16px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "16px 20px",
            borderBottom: "1px solid #e8ecf1",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            background: expandedSections.user ? "#f9fafb" : "white",
          }}
          onClick={() => toggleSection("user")}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <PersonIcon style={{ color: "#3b82f6", fontSize: "20px" }} />
            <h3 style={{ fontSize: "16px", fontWeight: 600, color: "#1a1a1a", margin: 0 }}>
              {i18n.t("birthdaySettings.userSection")}
            </h3>
          </div>
          <ExpandMoreIcon
            style={{
              color: "#6b7280",
              fontSize: "20px",
              transform: expandedSections.user ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
            }}
          />
        </div>

        {expandedSections.user && (
          <div style={{ padding: "20px" }}>
            <div style={{ marginBottom: "20px" }}>
              <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={settings?.userBirthdayEnabled || false}
                  onChange={(e) => handleSettingChange("userBirthdayEnabled", e.target.checked)}
                  style={{ marginRight: "8px", width: "16px", height: "16px", cursor: "pointer" }}
                />
                <span style={{ fontSize: "14px", color: "#1a1a1a", fontWeight: 500 }}>
                  {i18n.t("birthdaySettings.enableUserBirthday")}
                </span>
              </label>
              <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px", marginLeft: "24px" }}>
                {i18n.t("birthdaySettings.enableUserBirthdayDesc")}
              </div>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={settings?.createAnnouncementForUsers || false}
                  onChange={(e) => handleSettingChange("createAnnouncementForUsers", e.target.checked)}
                  disabled={!settings?.userBirthdayEnabled}
                  style={{ marginRight: "8px", width: "16px", height: "16px", cursor: "pointer" }}
                />
                <span style={{ fontSize: "14px", color: "#1a1a1a", fontWeight: 500 }}>
                  {i18n.t("birthdaySettings.createAnnouncement")}
                </span>
              </label>
              <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px", marginLeft: "24px" }}>
                {i18n.t("birthdaySettings.createAnnouncementDesc")}
              </div>
            </div>

            <div>
              <label style={{ fontSize: "13px", color: "#374151", fontWeight: 500, display: "block", marginBottom: "6px" }}>
                {i18n.t("birthdaySettings.userBirthdayMessage")}
              </label>
              <textarea
                value={settings?.userBirthdayMessage || ""}
                onChange={(e) => handleSettingChange("userBirthdayMessage", e.target.value)}
                disabled={!settings?.userBirthdayEnabled}
                rows={3}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "13px",
                  fontFamily: "inherit",
                  resize: "vertical",
                  opacity: settings?.userBirthdayEnabled ? 1 : 0.5,
                }}
              />
              <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>
                {i18n.t("birthdaySettings.useNameVariable")}
              </div>
              {renderMessagePreview(settings?.userBirthdayMessage)}
            </div>
          </div>
        )}
      </div>

      {/* Configurações de Contatos */}
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          border: "1px solid #e8ecf1",
          marginBottom: "16px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "16px 20px",
            borderBottom: "1px solid #e8ecf1",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            background: expandedSections.contact ? "#f9fafb" : "white",
          }}
          onClick={() => toggleSection("contact")}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <PhoneIcon style={{ color: "#10b981", fontSize: "20px" }} />
            <h3 style={{ fontSize: "16px", fontWeight: 600, color: "#1a1a1a", margin: 0 }}>
              {i18n.t("birthdaySettings.contactSection")}
            </h3>
          </div>
          <ExpandMoreIcon
            style={{
              color: "#6b7280",
              fontSize: "20px",
              transform: expandedSections.contact ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
            }}
          />
        </div>

        {expandedSections.contact && (
          <div style={{ padding: "20px" }}>
            <div style={{ marginBottom: "20px" }}>
              <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={settings?.contactBirthdayEnabled || false}
                  onChange={(e) => handleSettingChange("contactBirthdayEnabled", e.target.checked)}
                  style={{ marginRight: "8px", width: "16px", height: "16px", cursor: "pointer" }}
                />
                <span style={{ fontSize: "14px", color: "#1a1a1a", fontWeight: 500 }}>
                  {i18n.t("birthdaySettings.enableContactBirthday")}
                </span>
              </label>
              <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px", marginLeft: "24px" }}>
                {i18n.t("birthdaySettings.enableContactBirthdayDesc")}
              </div>
            </div>

            <div>
              <label style={{ fontSize: "13px", color: "#374151", fontWeight: 500, display: "block", marginBottom: "6px" }}>
                {i18n.t("birthdaySettings.contactBirthdayMessage")}
              </label>
              <textarea
                value={settings?.contactBirthdayMessage || ""}
                onChange={(e) => handleSettingChange("contactBirthdayMessage", e.target.value)}
                disabled={!settings?.contactBirthdayEnabled}
                rows={4}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "13px",
                  fontFamily: "inherit",
                  resize: "vertical",
                  opacity: settings?.contactBirthdayEnabled ? 1 : 0.5,
                }}
              />
              <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>
                {i18n.t("birthdaySettings.useNameAgeVariable")}
              </div>
              {renderMessagePreview(settings?.contactBirthdayMessage)}

              {settings?.contactBirthdayEnabled && (
                <button
                  onClick={() => handleTestMessage("contact")}
                  style={{
                    marginTop: "12px",
                    padding: "8px 16px",
                    background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                    e.target.style.boxShadow = "0 4px 12px rgba(245, 158, 11, 0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "none";
                    e.target.style.boxShadow = "none";
                  }}
                >
                  <SendIcon style={{ fontSize: "16px" }} />
                  {i18n.t("birthdaySettings.testMessage")}
                </button>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Configurações Gerais */}
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          border: "1px solid #e8ecf1",
          marginBottom: "16px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "16px 20px",
            borderBottom: "1px solid #e8ecf1",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            background: expandedSections.general ? "#f9fafb" : "white",
          }}
          onClick={() => toggleSection("general")}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <ScheduleIcon style={{ color: "#8b5cf6", fontSize: "20px" }} />
            <h3 style={{ fontSize: "16px", fontWeight: 600, color: "#1a1a1a", margin: 0 }}>
              {i18n.t("birthdaySettings.generalSection")}
            </h3>
          </div>
          <ExpandMoreIcon
            style={{
              color: "#6b7280",
              fontSize: "20px",
              transform: expandedSections.general ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
            }}
          />
        </div>

        {expandedSections.general && (
          <div style={{ padding: "20px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px", marginBottom: "20px" }}>
              <div>
                <label style={{ fontSize: "13px", color: "#374151", fontWeight: 500, display: "block", marginBottom: "6px" }}>
                  {i18n.t("birthdaySettings.sendTime")}
                </label>
                <input
                  type="time"
                  value={settings?.sendBirthdayTime?.substring(0, 5) || "09:00"}
                  onChange={(e) => {
                    const timeValue = e.target.value;
                    const formattedTime = timeValue ? `${timeValue}:00` : "09:00:00";
                    handleSettingChange("sendBirthdayTime", formattedTime);
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "13px",
                    fontFamily: "inherit",
                  }}
                />
                <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>
                  {i18n.t("birthdaySettings.sendTimeDesc")}
                </div>
              </div>

              <div>
                <label style={{ fontSize: "13px", color: "#374151", fontWeight: 500, display: "block", marginBottom: "6px" }}>
                  {i18n.t("birthdaySettings.whatsappConnection")}
                </label>
                <select
                  value={settings?.whatsappId || ""}
                  onChange={(e) => handleSettingChange("whatsappId", e.target.value || null)}
                  disabled={!settings?.contactBirthdayEnabled}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "13px",
                    fontFamily: "inherit",
                    opacity: settings?.contactBirthdayEnabled ? 1 : 0.5,
                  }}
                >
                  <option value="">{i18n.t("birthdaySettings.selectConnection")}</option>
                  {whatsApps?.length > 0 &&
                    whatsApps.map((whatsapp) => (
                      <option key={whatsapp.id} value={whatsapp.id}>
                        {whatsapp.name} ({whatsapp.status})
                      </option>
                    ))}
                </select>
                <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>
                  {i18n.t("birthdaySettings.whatsappConnectionDesc")}
                </div>
              </div>
            </div>

            <div
              style={{
                background: "#e3f2fd",
                border: "1px solid #90caf9",
                borderRadius: "8px",
                padding: "16px",
                display: "flex",
                gap: "12px",
              }}
            >
              <InfoIcon style={{ color: "#1976d2", fontSize: "20px", flexShrink: 0 }} />
              <div>
                <div style={{ fontSize: "13px", fontWeight: 600, color: "#1a1a1a", marginBottom: "8px" }}>
                  {i18n.t("birthdaySettings.variablesTitle")}
                </div>
                <div style={{ fontSize: "13px", color: "#374151" }}>
                  • <code style={{ background: "#fff", padding: "2px 6px", borderRadius: "3px", fontFamily: "monospace" }}>{"{nome}"}</code> - {i18n.t("birthdaySettings.variableName")}<br />
                  • <code style={{ background: "#fff", padding: "2px 6px", borderRadius: "3px", fontFamily: "monospace" }}>{"{idade}"}</code> - {i18n.t("birthdaySettings.variableAge")}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Botão Salvar */}
      <div style={{ textAlign: "center", marginTop: "24px" }}>
        <button
          onClick={handleSave}
          disabled={saving}
          style={{
            padding: "12px 32px",
            background: saving ? "#9ca3af" : "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: saving ? "not-allowed" : "pointer",
            fontSize: "14px",
            fontWeight: 600,
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            if (!saving) {
              e.target.style.transform = "translateY(-1px)";
              e.target.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.3)";
            }
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "none";
            e.target.style.boxShadow = "none";
          }}
        >
          <SaveIcon style={{ fontSize: "18px" }} />
          {saving ? i18n.t("birthdaySettings.saving") : i18n.t("birthdaySettings.saveSettings")}
        </button>
      </div>
    </div>
  );
};

export default BirthdaySettingsPage;